var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"new-content-button",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"new-content-button__font"},[_vm._t("default")],2),_vm._v(" "),(_vm.hasDropup)?_c('div',{staticClass:"mutant-icon new-content-button__arrow-up"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }